export { buildFacetFiltersFromRefinements } from '../utils/buildFacetFiltersFromRefinements'
export { getAutocompleteIndices } from '../utils/getAutocompleteIndices'
export { getFacetsForLocale } from '../utils/getFacetsForLocale'
export { buildAutocompleteQueries } from './buildAutocompleteQueries'
